import React from "react";
import {useForwardingBatchProvider} from "../../../Providers/ForwardingBatchProvider";
import {RenderBatchSectionType} from "../../../Types/ForwardingBatchTypes";
import {BatchYesNo} from "../Controls/BatchYesNo";

const BatchDetails = (props: RenderBatchSectionType) => {
    const { documentsOnly, UpdateDocumentsOnly } = useForwardingBatchProvider();

    return (
        <div>
            <h5 className={'mb-xs'}>Step {props.sectionIndex}: {props.section.name}</h5>

            <div className={'card p-md'}>
                <BatchYesNo
                    id={'documentsOnly'}
                    index={0}
                    isChecked={documentsOnly}
                    label={'Does your batch only contain documents?'}
                    groupName={'documentsOnly'}
                    checkOnly={true}
                    readOnly={props.readOnly}
                    onChange={(e: any) => {
                        UpdateDocumentsOnly(e.checked);
                    }}
                />
            </div>
        </div>
    )
}

export { BatchDetails }
